import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { deleteRequest } from 'src/utils/request';
import messages from 'src/pages/SetupPage/messages';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

const deleteTutorial = async (tutorialUuid: string) => {
  const { data } = await deleteRequest<RequestSimplifiedData>(
    API.DELETE.deleteTutorial(tutorialUuid),
  );
  return data;
};

export const useDeleteTutorial = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteTutorial,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialDeleted), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIALS] });
    },
    onError: handleError,
  });
};
